<script>
  export default {
    name: 'Testimonial',
  }
</script>
<template>
  <!--START TESTIMONIAL-->
  <section class="section" id="testi">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">¿Qué incluye la inversión inicial?</h1>
        </div>
      </div>
      <div class="container">
        <div class="row"> </div>
        <div class="row margin-t-30">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-shopbag text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Stock de mercadería inicial</h4>
                  <p class="pt-2 text-muted"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-cart text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Montaje del local (estanterías, infraestructura, equipos, etc)</h4>
                  <p class="pt-2 text-muted"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-id text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Licencia e implementación de software vinculado a la central</h4>
                  <p class="pt-2 text-muted"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-display2 text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Capacitación y entrenamiento</h4>
                  <p class="pt-2 text-muted"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-expand1 text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Exclusividad territorial</h4>
                  <p class="pt-2 text-muted"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-piggy text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Fee de entrada</h4>
                  <p class="pt-2 text-muted"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1 class="section-title text-center">Además</h1>
            <p class="text-center"
              >No se cobran royalties en forma independiente (están considerados en la
              venta de los productos) Cuentas con un Fondo de Mercadeo para la promoción y
              mantenimiento de la marca
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END TESTIMONIAL-->
</template>
